export default function BotaoAddAdmin({texto, clicado, type}){
    return(
        <button onClick={clicado} type={type} className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
            {texto}
        </button>
    )
}